"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var primary = function primary(theme) {
  return /*#__PURE__*/(0, _react.css)("height:", (0, _util.rem)(24), ";line-height:", (0, _util.rem)(24), ";border-radius:50rem;background-color:", theme.color.radioButtons.primary.background, ";white-space:nowrap;label:nth-of-type(odd){margin-right:-3px;}label:nth-of-type(even){margin-left:-3px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:primary;"));
};

var secondary = function secondary(theme) {
  return /*#__PURE__*/(0, _react.css)(primary(theme), ";background-color:", theme.color.radioButtons.secondary.background, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:secondary;"));
};

var styles = {
  primary: primary,
  secondary: secondary
};
exports.styles = styles;
//# sourceMappingURL=RadioButtons.styles.js.map